

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AllQuestions = () => {
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [questionsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [addPopup,setAddPopup]=useState(false)
  const [section,setSection]=useState([])
  const [subject,setSubject]=useState([])
  const [medium,setMedium]=useState([])
  const [examtypes, setExamtypes] = useState([]); 
  const [formData, setFormData] = useState({
  section_id: '',
  subject_id: '',
  medium_id: '',
  examtype:'',
  question: '',
  option_a: '',
  option_b: '',
  option_c: '',
  option_d: '',
  correct_option: '',
  derivation:'',
});

  
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};
    
  const getexamtype = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/questions/getexamtype`);
      

      // setExamtypes(filtered);
      setExamtypes(res.data.data);

      console.log(res.data.data)
    } catch (error) {
      console.log(error);
    }
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  // Check for empty fields
  const {
    section_id,
    subject_id,
    medium_id,
    examtype,
    question,
    option_a,
    option_b,
    option_c,
    option_d,
    correct_option,
  derivation,

  } = formData;

  if (
    !section_id ||
    !subject_id ||
    !medium_id ||
    !examtype||
    !question ||
    !option_a ||
    !option_b ||
    !option_c ||
    !option_d ||
    !correct_option
  ) {
    alert("❗ Please fill all the fields.");
    return;
  }

  try {
    console.log(formData)
    const response = await axios.post(`${process.env.REACT_APP_API}/questions/addQuestion`, formData);

    alert(response.data.message); // Show success message
    console.log('Question added:', response.data);

    setFormData({
      section_id: '',
      subject_id: '',
      medium_id: '',
       examtype:'',
      question: '',
      option_a: '',
      option_b: '',
      option_c: '',
      option_d: '',
      correct_option: '',
        derivation:'',

    });

    setAddPopup(false); // Close the modal
  } catch (error) {
    console.error('Error submitting question:', error);
    if (error.response?.data?.message) {
      alert(`❌ ${error.response.data.message}`);
    } else {
      alert('❌ Something went wrong. Please try again.');
    }
  }
};



  const getdata = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/getquestions`, {
        params: { page, limit: questionsPerPage },
      });

      setQuestions(response.data.questions);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching questions:', err);
      setError('Failed to fetch questions.');
      setLoading(false);
    }
  };

  useEffect(() => {
    getdata(1);
    getsection()
    getsubject()
 getmedium()
 getexamtype()

  }, []);

  const paginate = (pageNumber) => {
    getdata(pageNumber);
  };

  const filteredQuestions = questions.filter((q) =>
    q.question.toLowerCase().includes(searchTerm.toLowerCase())
  );


 const getsection=async()=>{
 try{
  const response = await axios.get(`${process.env.REACT_APP_API}/questions/getsection`)
  setSection(response.data.data)
  // console.log(response.data.data)

 }
 catch(error){
  console.log(error)
 }

 }


 const getsubject=async()=>{
 try{
  const response = await axios.get(`${process.env.REACT_APP_API}/questions/getsubject`)
  setSubject(response.data.score)
  // console.log(response.data.score)

 }
 catch(error){
  console.log(error)
 }

 }

 const getmedium=async()=>{
   try{
  const response = await axios.get(`${process.env.REACT_APP_API}/questions/getmedium`)
  setMedium(response.data.score)
  // console.log(response.data.score)

 }
 catch(error){
  console.log(error)
 }

 }


  return (
    <div style={{ padding: '30px', fontFamily: 'Segoe UI, sans-serif' }}>
      <h2 style={{ color: '#333', textAlign: 'center', marginBottom: '20px' }}>📝 All Questions</h2>

      {/* Search */}
      <input
        type="text"
        placeholder="🔍 Search Questions..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          marginBottom: '20px',
          padding: '10px',
          width: '100%',
          maxWidth: '400px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          outlineColor: '#007bff',
          fontSize: '16px',
        }}
      />
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
  <button
    style={{
      backgroundColor: '#28a745',
      color: 'white',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      cursor: 'pointer',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      transition: 'background-color 0.3s ease',
    }}
    // onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
    // onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}

 onClick={() => setAddPopup(true)} // ✅ Wrap in an arrow function

  >
    <strong>+</strong> Add
  </button>
</div>


      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {filteredQuestions.length > 0 ? (
        <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '10px' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              backgroundColor: '#fff',
              boxShadow: '0 0 10px rgba(0,0,0,0.05)',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <thead style={{ backgroundColor: '#007bff', color: '#fff' }}>
              <tr>
                <th style={thStyle}>ID</th>
                <th style={thStyle}>Question</th>
                <th style={thStyle}>Option A</th>
                <th style={thStyle}>Option B</th>
                <th style={thStyle}>Option C</th>
                <th style={thStyle}>Option D</th>
                <th style={thStyle}>Correct</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuestions.map((q, index) => (
                <tr key={q.id || index} style={index % 2 === 0 ? rowEven : rowOdd}>
                  <td style={tdStyle}>{q.id}</td>
                  <td style={tdStyle}>{q.question}</td>
                  <td style={tdStyle}>{q.option_a}</td>
                  <td style={tdStyle}>{q.option_b}</td>
                  <td style={tdStyle}>{q.option_c}</td>
                  <td style={tdStyle}>{q.option_d}</td>
                  <td style={tdStyle}>{q.correct_option}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        !loading && <p>No questions found.</p>
      )}

      {/* Pagination */}
      <div
        style={{
          marginTop: '25px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          style={buttonStyle(currentPage === 1)}
        >
          ⬅ Previous
        </button>

        <span style={{ fontSize: '16px', color: '#444' }}>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </span>

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={buttonStyle(currentPage === totalPages)}
        >
          Next ➡
        </button>
      </div>
 {addPopup && (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}
  >
    {/* Modal Content */}
    <div
      style={{
        position: 'relative',
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        width: '400px',
        minWidth: '200px',
        maxHeight:'95vh',
        overflowX:"auto"
      }}
    >
      {/* Close Button */}
     <button
  onClick={() => setAddPopup(false)}
  style={{
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: '#e53935', // Bright red
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.3s ease',
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.background = '#c62828';
    e.currentTarget.style.transform = 'scale(1.1)';
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.background = '#e53935';
    e.currentTarget.style.transform = 'scale(1)';
  }}
  aria-label="Close"
>
  &times;
</button>


      <h3 style={{ marginTop: 0 }}>Add Questions</h3>


<form
  onSubmit={handleSubmit}
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px',
    background: '#f9f9f9',
    borderRadius: '10px',
  }}
>
  {/* Custom Form Field Style */}
  {[
    {
      type: 'select',
      name: 'section_id',
      options: section,
      label: 'Select Section',
      key: 'section_name',
    },
    {
      type: 'select',
      name: 'subject_id',
      options: subject,
      label: 'Select Subject',
      key: 'subject_name',
    },
    {
      type: 'select',
      name: 'medium_id',
      options: medium,
      label: 'Select Medium',
      key: 'medium_name',
    },
  ].map(({ type, name, options, label, key }) => (
    <select
      key={name}
      name={name}
      value={formData[name]}
      onChange={handleChange}
      style={{
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        fontSize: '15px',
        background: '#fff',
        outlineColor: '#007bff',
      }}
    >
      <option value="">{label}</option>
      {options.map((value, i) => (
        <option key={i} value={value.id}>
          {value[key]}
        </option>
      ))}
    </select>
  ))}
   

     <select
      id="standard"
      name="examtype"
      // className="form-control"
       style={{
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        fontSize: '15px',
        background: '#fff',
        outlineColor: '#007bff',
      }}
      value={formData.examtype}
      onChange={handleChange}
      required
    >
   {
  // examtypes.filter(exam => 
  //   exam.section_names
  //     ?.split(',')
  //     .map(name => name.trim())
  //     .includes(formData.standard)
  // ).length === 0 ? (
  //   <option value="">No Exam Scheduled</option>
  // ) : (
    <>
      <option value="">Select Exam Type</option>
      {examtypes
        // .filter(exam =>
        //   exam.section_names
        //     ?.split(',')
        //     .map(name => name.trim())
        //     .includes(formData.standard)
        // )
        .map((exam) => (
          <option key={exam.id} value={exam.id}>
            {exam.title}
          </option>
        ))}
    </>
  // )
}

    </select>
  {/* Text Inputs */}
  {['question', 'option_a', 'option_b', 'option_c', 'option_d'].map((field) => (
    <input
      key={field}
      type="text"
      name={field}
      value={formData[field]}
      onChange={handleChange}
      placeholder={field.replace('_', ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
      style={{
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        fontSize: '15px',
        background: '#fff',
        outlineColor: '#007bff',
      }}
    />
  ))}

  {/* Correct Option */}
  <select
    name="correct_option"
    value={formData.correct_option}
    onChange={handleChange}
    style={{
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      fontSize: '15px',
      background: '#fff',
      outlineColor: '#007bff',
    }}
  >
    <option value="">Select Correct Option</option>
    <option value="option_a">Option A</option>
    <option value="option_b">Option B</option>
    <option value="option_c">Option C</option>
    <option value="option_d">Option D</option>
  </select>


   <input type="text" 
   placeholder='Derivation'
   name='derivation'
   value={formData.derivation}
   onChange={handleChange}
    style={{
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        fontSize: '15px',
        background: '#fff',
        outlineColor: '#007bff',
      }}/>


  {/* Submit Button */}
  <button
    type="submit"
    style={{
      padding: '12px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      cursor: 'pointer',
      fontWeight: 'bold',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
      transition: 'all 0.3s ease',
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0056b3')}
    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#007bff')}
  >
    ➕ Add Question
  </button>
</form>


      {/* Add your form or content here */}
    </div>
  </div>
)}


    </div>
  );
};

export default AllQuestions;

// Reusable styles
const thStyle = {
  padding: '12px 15px',
  textAlign: 'left',
  fontWeight: '600',
  fontSize: '15px',
};

const tdStyle = {
  padding: '12px 15px',
  fontSize: '14px',
  color: '#333',
};

const rowEven = {
  backgroundColor: '#f9f9f9',
};

const rowOdd = {
  backgroundColor: '#fff',
};

const buttonStyle = (disabled) => ({
  padding: '10px 18px',
  backgroundColor: disabled ? '#ccc' : '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  fontSize: '15px',
  transition: 'all 0.3s ease',
  boxShadow: disabled ? 'none' : '0 2px 6px rgba(0,0,0,0.1)',
});
